'use client'

import { ASvg, SeomaticData } from 'ui'
import { useTranslation } from 'react-i18next'
import SvgStaarSurgicalLogo from 'ui/svg/logos/staar-surgical/teal-black.svg'
import './c-locale-switcher-screen.css'
import { LocaleSwitcherEntry } from 'tsconfig/craft-types'
import { CLocaleSwitcherContent } from './c-locale-switcher-content'

export type LocaleSwitcherEntity = {
  seomatic: SeomaticData
} & LocaleSwitcherEntry

type Props = {
  entry: LocaleSwitcherEntity
}

export const CLocaleSwitcherScreen = ({ entry }: Props) => {
  const { t } = useTranslation('common')

  return (
    <div className="c-locale-switcher-screen px-5 pb-5 bg-primary-teal w-full min-h-screen flex flex-col items-center relative overflow-hidden">
      <div className="c-locale-switcher-screen__background absolute inset-0 pointer-events-none">
        <img
          className="c-locale-switcher-screen__background-image absolute w-full right-0 md:h-full object-cover object-bottom md:object-left opacity-50"
          src={entry.backgroundImage?.[0]?.url}
          alt="Eye background"
        />
        <div className="c-locale-switcher-screen__background-gradient md:h-full absolute bg-gradient-to-t md:bg-gradient-to-r from-primary-teal to-transparent" />
        <img
          src={entry.desktopEllipsesImage?.[0]?.url}
          className="c-locale-switcher-screen__background-ellipses absolute hidden md:block opacity-75"
          alt="Background shape"
        />
      </div>
      <ASvg
        className="c-locale-switcher-screen__logo my-5 fill-current text-neutral-white z-10"
        svg={SvgStaarSurgicalLogo}
        aria-label={`Staar Surgical ${t('logo')}`}
      />

      <CLocaleSwitcherContent
        domain={process.env.NEXT_PUBLIC_DISCOVERICL_BASE_DOMAIN ?? ''}
        entry={entry}
        title={entry.title}
        backgroundColor={entry.containerBackgroundColor}
      />
    </div>
  )
}